exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.integration-box[data-v-f60b9038] {\n    background-color: #f8f9fa;\n    padding: 15px;\n    border-radius: 4px;\n}\n.integration-item[data-v-f60b9038] {\n    background-color: #fff;\n}\n.note[data-v-f60b9038] {\n    background-color: #f8f9fa;\n    padding: 10px;\n    border-radius: 4px;\n}\n", ""]);

// exports
